var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAeroPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.961 1.39502C7.34815 0.581226 8.5417 0.174331 9.1837 0.816306C9.82565 1.45828 9.41875 2.65186 8.605 5.039L8.0508 6.6646C7.42585 8.4979 7.11335 9.41455 6.5982 9.4904C6.45975 9.5108 6.3164 9.49855 6.17935 9.45455C5.66975 9.29095 5.40035 8.32445 4.86155 6.3915C4.74205 5.96275 4.6823 5.74835 4.5462 5.5846C4.5067 5.5371 4.4629 5.4933 4.4154 5.4538C4.25165 5.3177 4.03725 5.25795 3.60852 5.13845C1.67555 4.59965 0.709068 4.33025 0.545448 3.82064C0.501458 3.68362 0.489183 3.54027 0.509578 3.40178C0.585438 2.88666 1.50209 2.57417 3.3354 1.94919L4.961 1.39502Z",
    stroke: "black",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAeroPlane);
export default __webpack_public_path__ + "static/media/aero-plane.a7698c8c39f8daeb5fa4eb0d861118dc.svg";
export { ForwardRef as ReactComponent };